var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var TransitionHeight = /** @class */ (function (_super) {
    __extends(TransitionHeight, _super);
    function TransitionHeight() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.percentageStep = 0;
        return _this;
    }
    TransitionHeight.prototype.updatePercentageStep = function () {
        this.percentageStep = 60 / this.duration;
    };
    TransitionHeight.prototype.enter = function (element, done) {
        var _this = this;
        this.updatePercentageStep();
        var percentage = 0;
        var step = function () {
            var targetHeight = element.scrollHeight;
            element.style.maxHeight = "".concat(targetHeight * percentage, "px");
            percentage += _this.percentageStep;
            if (percentage < 1) {
                window.requestAnimationFrame(step);
            }
            else {
                element.style.maxHeight = "".concat(targetHeight, "px");
                done();
            }
        };
        step();
    };
    TransitionHeight.prototype.leave = function (element, done) {
        var _this = this;
        this.updatePercentageStep();
        var targetHeight = element.scrollHeight;
        var percentage = 1;
        var step = function () {
            element.style.maxHeight = "".concat(targetHeight * percentage, "px");
            percentage -= _this.percentageStep;
            if (percentage > 0) {
                window.requestAnimationFrame(step);
            }
            else {
                element.style.maxHeight = "".concat(0, "px");
                done();
            }
        };
        step();
    };
    __decorate([
        Prop({ type: Number, default: 500 })
    ], TransitionHeight.prototype, "duration", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], TransitionHeight.prototype, "appear", void 0);
    TransitionHeight = __decorate([
        Component({ components: {} })
    ], TransitionHeight);
    return TransitionHeight;
}(Vue));
export default TransitionHeight;
